import { useState, useEffect } from 'react';
import { useAdsConfigService, AdPlacementConfig } from '../services';

interface UseAdPlacementConfigReturn {
	config: AdPlacementConfig | null;
	loading: boolean;
	error: string | null;
}

export const useAdPlacementConfig = (): UseAdPlacementConfigReturn => {
	const { getAdPlacementConfig } = useAdsConfigService();
	const [config, setConfig] = useState<AdPlacementConfig | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchConfig = async () => {
			try {
				const data = await getAdPlacementConfig();
				setConfig(data);
			} catch (err: any) {
				setError(err.message || 'Failed to fetch ad placement configuration');
			} finally {
				setLoading(false);
			}
		};

		fetchConfig();
	}, []); // Empty dependency array - run only once on mount

	return {
		config,
		loading,
		error
	};
};
